// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Gambia from '../_raw/flag/icon_flag_gambia.png';

export default () => <img src={Gambia} alt="Gambia" />;
